<script>
    let version = 'APP_VERSION'

    if(version === "undefined")
        version = '1.0.0'
</script>

<footer class="footer">©2019 IoT Reno - Version {version}</footer>